import { EntityBase, Var } from "addeus-common-library/stores/firestore";
import moment from "moment-with-locales-es6";
import { AnalysedData } from "./aiDatas";

export class CommentAudit extends EntityBase {
    @Var(moment)
    publishedAt?: moment;

    @Var(String)
    text?: string;

    @Var(String)
    id?: string;
}

export class MediaAudit extends EntityBase {
    @Var(String)
    id?: string;

    @Var(String)
    caption?: string;

    @Var(String)
    media?: string;

    @Var(Number)
    likes?: number;

    @Var(Number)
    commentCount?: number;

    @Var(Number)
    urlClicks?: number;

    @Var(Number)
    saved?: number;

    @Var(moment)
    publishedAt?: moment;

    @Var(String)
    type?: string;

    @Var(Number)
    shares?: number;

    @Var(String)
    url?: string;

    @Var(String)
    downloadedMedia?: string;

    @Var(Array.of(CommentAudit))
    comments: CommentAudit[] = [];

    @Var(AnalysedData)
    visualQuality?: AnalysedData;

    @Var(AnalysedData)
    contentOptimization?: AnalysedData;

    @Var(AnalysedData)
    hashtagQuality?: AnalysedData;

    @Var(AnalysedData)
    targetAudience?: AnalysedData;

    get engagement(): number {
        return (this.likes || 0) + (this.commentCount || 0) + (this.shares || 0);
    }
}
